import state from './moduleTripsState'
import mutations from './moduleTripsMutations'
import actions from './moduleTripsActions'
import getters from './moduleTripsGetters'

export default {
  namespaced: true,
  state, 
  mutations,
  actions,
  getters
}